(function () {
    initializeUtilsFunctions();
    executeOnce('free-filter-icon', function () {
        const $icons = [].slice.call(document.querySelectorAll('#free-filter-icon'));

        //toggle searchBar
        function toggleSearchBar() {
            const searchBar = document.querySelector('.search-container');
            if (searchBar) {
                searchBar.classList.toggle('active');
                searchBar.querySelector('input').focus();
            }
        }

        //bind action for searchBar
        function search() {
            const searchBar = document.querySelector('.search-container');
            if (searchBar){
              searchBar.removeEventListener('submit', () => {
              });
              searchBar.addEventListener('submit', (e) => {
                e.preventDefault();
                const $input = e.currentTarget.parentNode.querySelector('input');
                if (!!$input.value) {
                  let uri = searchBar.querySelector('form').action || '/filters';
                  uri = uri + '?search=' + $input.value;
                  location.assign(sanitizeUri(uri));
                }
              });
            }
            const $cta = document.querySelector('.cta-send-free-search');
            if ($cta){
              $cta.addEventListener('click', (e) => {
                const $input = e.currentTarget.parentNode.querySelector('input');
                if (!!$input.value) {

                  let uri = searchBar.querySelector('form').action || '/filters';
                  uri = sanitizeUri(uri) + '?search=' + $input.value;
                  window.location.href = uri;
                }
              })
            }
        }

        //bind icon
        $icons.forEach(icon => {
            icon.addEventListener('click', toggleSearchBar);
        });

        search();
    })
}());
